import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useFusion } from '@rendering/fusion-react';
import { useCallback } from 'react';
export function FusionPanelPreview({ children, cimDoc, user, page, width, onError, onPaint, onFusionPaint, fusionOptions }) {
    const [status, setStatus] = useState({ loading: false });
    const canvasRef = useRef(null);
    const onInnerError = useCallback((e) => {
        onError === null || onError === void 0 ? void 0 : onError(e);
        setStatus({ loading: false, error: e });
    }, [onError]);
    const dimension = useMemo(() => ({ width }), [width]);
    const selectors = useMemo(() => [
        {
            type: 'page',
            number: page,
        },
    ], [page]);
    const onInnerPaint = useCallback((args) => {
        onPaint === null || onPaint === void 0 ? void 0 : onPaint();
        onFusionPaint === null || onFusionPaint === void 0 ? void 0 : onFusionPaint(args);
    }, [onPaint, onFusionPaint]);
    const getCanvas = useCallback(() => canvasRef.current, []);
    const { loading } = useFusion({
        cimDoc,
        dimension,
        onError: onInnerError,
        onPaint: onInnerPaint,
        referrer: user.referer,
        selectors,
        textOptions: fusionOptions.textOptions,
        getCanvas,
        debugOptions: fusionOptions === null || fusionOptions === void 0 ? void 0 : fusionOptions.debugOptions,
        experimentalOptions: fusionOptions === null || fusionOptions === void 0 ? void 0 : fusionOptions.experimentalOptions,
    });
    useEffect(() => {
        setStatus({ loading, error: null });
    }, [loading]);
    const Canvas = useCallback((props) => React.createElement("canvas", Object.assign({ ref: canvasRef, style: { width: '100%' } }, props)), []);
    if (!children) {
        return React.createElement(Canvas, null);
    }
    return React.createElement(React.Fragment, null, children({ Canvas, status }));
}
//# sourceMappingURL=FusionPanelPreview.js.map